import React from "react"
import { Chip, Grid2 } from "@mui/material"

import { Text } from "@/components/Text"
import { InputLabelProps } from "@/components/Input/protocols"

import useStyles from "@/components/Input/Label/styles"
import { themeColors } from "@/styles"

export const Label = ({
	label,
	subLabel,
	isOptional
}: InputLabelProps) => {
	const classes = useStyles()

	if (!label) {
		return null
	}

	return (
		<Grid2 container spacing={0.5}>
			<Grid2 size={12}>
				<Grid2 container alignItems="center" spacing={1}>
					<Grid2>
						<Text.Body
							type="small1"
							fontWeight="bold"
							color={themeColors.getTextColor()}
						>
							{label}
						</Text.Body>
					</Grid2>
					{isOptional && (
						<Grid2>
							<Chip
								label={(
									<Text.Body
										type="smaller2"
										fontWeight="regular"
										color={themeColors.getTextColor()}
									>
										Opcional
									</Text.Body>
								)}
								sx={classes.chip}
							/>
						</Grid2>
					)}
				</Grid2>
			</Grid2>
			{subLabel && (
				<Grid2 size={12}>
					<Text.Body
						type="small2"
						fontWeight="regular"
						color={themeColors.colors.system.gray[400]}
					>
						{subLabel}
					</Text.Body>
				</Grid2>
			)}
		</Grid2>
	)
}